import { useAlertMutations } from "./useAlertMutations";
import { useAppNotification } from "./useAppNotification";

export const useAlertDeletion = () => {
  const { deleteAlert } = useAlertMutations();
  const { openSuccessNotification, openErrorNotification, contextHolder } =
    useAppNotification();

  const deleteAlertWithFeedback = (
    alertId: string,
    onComplete?: () => void,
  ) => {
    deleteAlert(alertId, {
      onSuccess: () => {
        openSuccessNotification({
          title: (
            <p className="text-[#003832] text-base font-semibold">
              Alert Deleted
            </p>
          ),
          description: (
            <p className="text-[#2B4752] text-[14px]">
              The alert has been successfully deleted.
            </p>
          ),
          placement: "bottom",
          className: "insight-success-confirmation",
          duration: 2,
          icon: null,
        });
        onComplete?.();
      },
      onError: (error) => {
        console.error("Failed to delete alert:", error);
        openErrorNotification({
          title: (
            <p className="text-[#73134A] text-base font-semibold">
              Delete Failed
            </p>
          ),
          description: (
            <p className="text-[#260618] text-[14px]">
              There was an error deleting the alert. Please try again.
            </p>
          ),
          placement: "bottom",
          className: "insight-error-confirmation",
          duration: 2,
          icon: null,
        });
        onComplete?.();
      },
    });
  };

  return {
    contextHolder,
    deleteAlertWithFeedback,
  };
};
